// relationship status
export enum RELATIONSHIP_STATUS {
  MARRIED = 'married',
  SINGLE = 'single',
  WIDOW = 'widow',
  DEFACTO = 'defacto',
  SEPARATED = 'separated',
  DIVORCED = 'divorced',
}

export enum RELATIONSHIP_STATUS_UK {
  MARRIED = 'married',
  ENGAGED = 'engaged',
  SINGLE = 'single',
  WIDOW = 'widow',
  DEFACTO = 'defacto',
  CIVIL_PARTNERSHIP = 'civilPartnership',
  SEPARATED = 'separated',
  DIVORCED = 'divorced',
}

export const relationshipStatusOptions = Object.values(RELATIONSHIP_STATUS)

export type RelationshipStatus = (typeof relationshipStatusOptions)[number]

export const relationshipStatusMap = {
  [RELATIONSHIP_STATUS.MARRIED]: 'Married',
  [RELATIONSHIP_STATUS.SINGLE]: 'Single',
  [RELATIONSHIP_STATUS.WIDOW]: 'Widow',
  [RELATIONSHIP_STATUS.DEFACTO]: 'Defacto',
  [RELATIONSHIP_STATUS.SEPARATED]: 'Separated',
  [RELATIONSHIP_STATUS.DIVORCED]: 'Divorced',
}

export const relationshipStatusMapUK: Record<RELATIONSHIP_STATUS_UK, string> = {
  [RELATIONSHIP_STATUS_UK.MARRIED]: 'Married',
  [RELATIONSHIP_STATUS_UK.SINGLE]: 'Single',
  [RELATIONSHIP_STATUS_UK.ENGAGED]: 'Engaged',
  [RELATIONSHIP_STATUS_UK.DEFACTO]: 'Living With Partner',
  [RELATIONSHIP_STATUS_UK.CIVIL_PARTNERSHIP]: 'Civil Partnership',
  [RELATIONSHIP_STATUS_UK.DIVORCED]: 'Divorced',
  [RELATIONSHIP_STATUS_UK.SEPARATED]: 'Separated',
  [RELATIONSHIP_STATUS_UK.WIDOW]: 'Widow',
}
